import axiosInstance from "./axiosInstance";

export const fetchCategories = async (params = {}) => {
  try {
    const res = await axiosInstance.get("/categories", { params });
    return res.data;
  } catch (error) {
    throw error;
  }
};

export const fetchFeaturedCategories = async () => {
  try {
    const res = await axiosInstance.get("/categories/featured");
    return res.data;
  } catch (error) {
    throw error;
  }
};

export const updateCategory = async (id, categoryData) => {
  try {
    const res = await axiosInstance.put(`/categories/${id}`, categoryData);
    return res.data;
  } catch (error) {
    throw error;
  }
};

export const fetchAllCategory = async () => {
  try {
    const res = await axiosInstance.get("/getallcategories");
    return res.data;
  } catch (error) {
    throw error;
  }
};

export const deleteCategory = async (id) => {
  try {
    const res = await axiosInstance.delete(`/categories/${id}`);
    return res.data;
  } catch (error) {
    throw error;
  }
};

export const fetchActiveCategories = async () => {
  try {
    const res = await axiosInstance.get("/categories/active");
    return res.data;
  } catch (error) {
    throw error;
  }
};

export const createCategory = async (categoryData) => {
  try {
    const res = await axiosInstance.post("/categories", categoryData);
    return res.data;
  } catch (error) {
    throw error;
  }
};

export const fetchCategoryById = async (id) => {
  try {
    const res = await axiosInstance.get(`/categories/${id}`);
    return res.data;
  } catch (error) {
    throw error;
  }
};

export const fetchCategoryBySlug = async (slug) => {
  try {
    const res = await axiosInstance.get(`/categories/slug/${slug}`);
    return res.data;
  } catch (error) {
    throw error;
  }
};

export async function createCat(data) {
  try {
    const res = await axiosInstance.post("/categories", data);
    return res.data;
  } catch (error) {
    throw error;
  }
}

export const fetchCategoryStats = async () => {
  try {
    const res = await axiosInstance.get("/categories/admin/stats");
    return res.data;
  } catch (error) {
    throw error;
  }
};

export const searchCategories = async (searchTerm) => {
  try {
    const res = await axiosInstance.get("/categories", {
      params: { search: searchTerm }
    });
    return res.data;
  } catch (error) {
    throw error;
  }
};
